import { createContext } from 'react'

const BrandbookConfigContext = createContext()

export default BrandbookConfigContext
